import { useState } from "react";
import { Button, Popover, Spin, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "~/store/initializeStore";

/**
 * The activity event only carries `hasComment` (the comment itself never
 * leaves the feedback row), so the text is fetched when the popover opens.
 * That also covers events published before the comment could have been
 * embedded in the payload.
 */
export const DishFeedbackCommentPopover = ({ feedbackId }: { feedbackId: string }) => {
  const [open, setOpen] = useState(false);
  const query = useQuery({
    queryKey: ["dish-feedback", "comment", feedbackId],
    enabled: open,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("client_dish_feedback")
        .select("comment")
        .eq("id", feedbackId)
        .maybeSingle();
      if (error) throw error;
      return data?.comment ?? null;
    },
  });

  const content = query.isError ? (
    <Typography.Text type="danger">Nie udało się pobrać komentarza.</Typography.Text>
  ) : query.isLoading ? (
    <Spin size="small" />
  ) : query.data === null ? (
    <Typography.Text type="secondary">Ta opinia została usunięta.</Typography.Text>
  ) : (
    <div style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", maxWidth: 360 }}>{query.data}</div>
  );

  return (
    <Popover trigger="click" open={open} onOpenChange={setOpen} title="Komentarz klientki" content={content}>
      <Button type="link" size="small" style={{ padding: 0, height: "auto" }}>
        Pokaż komentarz
      </Button>
    </Popover>
  );
};
